import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-1 relative z-0 flex overflow-visible my-6 h-[95%]" }
const _hoisted_2 = { class: "flex flex-1 relative z-0 overflow-visible focus:outline-none xl:order-last" }
const _hoisted_3 = { class: "absolute inset-0 py-2 pl-0 lg:pl-4" }
const _hoisted_4 = { class: "h-full bg-white shadow-modal rounded-lg flex flex-col" }
const _hoisted_5 = { class: "relative order-first flex flex-col flex-shrink-0 w-full xl:w-96" }
const _hoisted_6 = { class: "absolute inset-0 py-2 pr-0 lg:pr-4" }


import { useBreakpoints, breakpointsTailwind } from '@vueuse/core';
import ActiveConversationMessages from './components/ActiveConversationMessages.vue';
import ConversationList from './components/ConversationList.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  homeId: {
    type: String,
    required: false,
    default: '4637497238jhb',
  },
},
  setup(__props) {



const auth = {
  currentUser: {
    uid: '234t823y48jhj',
  },
};
const conversations = {
  activeConversation: true,
  activeConversationId: '3547890fghv',
  toggleConversation: () => {
    console.log('toggle conversation');
  },
  conversations: [],
};

// const conversationIdParam = useRouteQuery('conversation')

const breakpoints = useBreakpoints(breakpointsTailwind);
const smallerThanLg = breakpoints.smaller('lg');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (conversations.activeConversation)
            ? (_openBlock(), _createBlock(ActiveConversationMessages, { key: 0 }))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, !_unref(smallerThanLg) || conversations.activeConversation]
    ]),
    _withDirectives(_createElementVNode("aside", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(ConversationList, {
          conversations: conversations.conversations,
          "current-user-id": auth.currentUser?.uid,
          "active-conversation-id": conversations.activeConversationId,
          onToggleConversation: _cache[0] || (_cache[0] = ($event: any) => (conversations.toggleConversation($event)))
        }, null, 8, ["conversations", "current-user-id", "active-conversation-id"])
      ])
    ], 512), [
      [_vShow, !_unref(smallerThanLg) || !conversations.activeConversation]
    ])
  ]))
}
}

})